// Connects to backend WebSocket /api/v1/ws/ticker which relays BiQuote ticks.
// Frontend just receives {symbol, price, change} JSON messages.
// If WS fails to open, calls onFallback() so caller can switch to REST polling.
import { API } from "@/lib/api";

let ws = null;
let connecting = false;
let connectionTimer = null;
const listeners = new Map(); // callback -> { onTick, onFallback }
const FALLBACK_MS = 4000;

function wsUrl() {
  const u = new URL(API);
  const proto = u.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${u.host}/api/v1/ws/ticker`;
}

function ensureConnection() {
  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) return;
  if (connecting) return;
  connecting = true;
  try {
    ws = new WebSocket(wsUrl());
  } catch {
    connecting = false;
    triggerFallback();
    return;
  }
  connectionTimer = setTimeout(() => {
    if (ws && ws.readyState !== WebSocket.OPEN) {
      triggerFallback();
    }
  }, FALLBACK_MS);
  ws.onopen = () => {
    connecting = false;
    if (connectionTimer) { clearTimeout(connectionTimer); connectionTimer = null; }
  };
  ws.onerror = () => {};
  ws.onclose = () => {
    connecting = false;
    if (connectionTimer) { clearTimeout(connectionTimer); connectionTimer = null; }
    ws = null;
    if (listeners.size) triggerFallback();
  };
  ws.onmessage = (ev) => {
    try {
      const tk = JSON.parse(ev.data);
      if (!tk || !tk.symbol) return;
      listeners.forEach(({ onTick }) => { try { onTick(tk); } catch {} });
    } catch {}
  };
}

function triggerFallback() {
  listeners.forEach(({ onFallback }) => {
    try { onFallback(); } catch {}
  });
}

export function subscribeBiquote(_symbols, onTick, onFallback) {
  listeners.set(onTick, { onTick, onFallback: onFallback || (() => {}) });
  ensureConnection();
  return () => {
    listeners.delete(onTick);
    if (!listeners.size && ws) {
      try { ws.close(); } catch {}
      ws = null;
    }
  };
}
